import type { IntlShape } from 'react-intl-next';

import {
	DefaultExtensionProvider,
	type ExtensionProvider,
} from '@atlaskit/editor-common/extensions';

import { getSessionData } from '@confluence/session-data/entry-points/SessionData';

import { fetchSnippetsFromAPI, type Snippet } from '../services/snippetApi';

import { snippetExtensionManifest } from './snippetExtensionManifest';

export const snippetExtensionProvider = async (intl: IntlShape): Promise<ExtensionProvider> => {
	try {
		// TODO: Replace with actual API call when backend is ready
		const snippets: Snippet[] = await fetchSnippetsFromAPI();

		if (!snippets || snippets.length === 0) {
			return new DefaultExtensionProvider([]);
		}

		const { displayName } = await getSessionData();
		const manifest = snippetExtensionManifest({
			snippets,
			currentUserDisplayName: displayName,
			intl,
		});

		return new DefaultExtensionProvider([manifest]);
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error('Failed to create snippet extension provider:', error);
		return new DefaultExtensionProvider([]);
	}
};
